/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    SSRV2RuleFormDataTravelDateRestriction,
    SSRV2RuleFormDataTravelDateRestrictionFromJSON,
    SSRV2RuleFormDataTravelDateRestrictionFromJSONTyped,
    SSRV2RuleFormDataTravelDateRestrictionToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRV2RuleUpdateRequest
 */
export interface SSRV2RuleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleUpdateRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleUpdateRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleUpdateRequest
     */
    contactEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleUpdateRequest
     */
    contactMobile?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SSRV2RuleUpdateRequest
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SSRV2RuleUpdateRequest
     */
    providers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SSRV2RuleUpdateRequest
     */
    carriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof SSRV2RuleUpdateRequest
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof SSRV2RuleUpdateRequest
     */
    bookingDateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof SSRV2RuleUpdateRequest
     */
    bookingDateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {Array<SSRV2RuleFormDataTravelDateRestriction>}
     * @memberof SSRV2RuleUpdateRequest
     */
    travelDates?: Array<SSRV2RuleFormDataTravelDateRestriction> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleUpdateRequest
     */
    excludeCarriers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleUpdateRequest
     */
    disabled?: boolean;
}

export function SSRV2RuleUpdateRequestFromJSON(json: any): SSRV2RuleUpdateRequest {
    return SSRV2RuleUpdateRequestFromJSONTyped(json, false);
}

export function SSRV2RuleUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'contactEmail': !exists(json, 'contactEmail') ? undefined : json['contactEmail'],
        'contactMobile': !exists(json, 'contactMobile') ? undefined : json['contactMobile'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'bookingDateTimeRestrictions': !exists(json, 'bookingDateTimeRestrictions') ? undefined : (json['bookingDateTimeRestrictions'] === null ? null : (json['bookingDateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'bookingDateTimeRestrictionsTimeZone': !exists(json, 'bookingDateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['bookingDateTimeRestrictionsTimeZone']),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(SSRV2RuleFormDataTravelDateRestrictionFromJSON)),
        'excludeCarriers': !exists(json, 'excludeCarriers') ? undefined : json['excludeCarriers'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function SSRV2RuleUpdateRequestToJSON(value?: SSRV2RuleUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
        'comment': value.comment,
        'contactEmail': value.contactEmail,
        'contactMobile': value.contactMobile,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'bookingDateTimeRestrictions': value.bookingDateTimeRestrictions === undefined ? undefined : (value.bookingDateTimeRestrictions === null ? null : (value.bookingDateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'bookingDateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.bookingDateTimeRestrictionsTimeZone),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(SSRV2RuleFormDataTravelDateRestrictionToJSON)),
        'excludeCarriers': value.excludeCarriers,
        'disabled': value.disabled,
    };
}


